import React, { useState, useEffect } from 'react';
import funcTranslateHelper from '../../../i18next/funcTranslateHelper';
import { useDrop } from 'react-dnd-cjs';
import TransitionForm from './TransitionForm';
import Assets from './Assets';
import { Grid, Card, CardContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronDown16 } from '@carbon/icons-react';
import Collapse from 'react-bootstrap/Collapse';
import './SubStages.css';

const useStyles = makeStyles({
  card: {
    height: '100%',
    minHeight: '90px',
    backgroundColor: 'white',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10
  },
  content: {
    padding: '0px',
    height: '100%',
    '&:last-child': {
      paddingBottom: '20px'
    },
    position: 'relative'
  },
  bottom: {
    position: 'absolute',
    bottom: 0,
    height: 4,
    width: '100%'
  },
  title: {
    fontFamily: 'Roboto-Regular',
    fontWeight: '500',
    lineHeight: '22px',
    fontSize: '20px',
    color: 'rgba(0,0,0,0.87)',
    paddingTop: 19,
    paddingLeft: 18.4,
    marginBottom: 0,
    width: 148
  },
  items: {
    fontFamily: 'Roboto-Regular',
    fontWeight: '500',
    fontSize: '14px',
    color: 'rgba(0,0,0,0.60)',
    letterSpacing: '0.25px',
    textAlign: 'left',
    lineHeight: '20px',
    paddingTop: 11,
    paddingLeft: 18.4,
    marginBottom: 0,
    width: 148
  },
  scroll: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    maxHeight: '280px',
    minHeight: '100px',
    marginTop: '5px'
  }
});

function SubStages ({ stages, assets, configFile, filteredAssets }) {
  const classes = useStyles();
  const [form, setForm] = useState(false);
  const [formProps, setFormProps] = useState({});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (Object.keys(formProps).length !== 0) {
      setForm(true);
    }
  }, [formProps]);

  async function setFormTranstion (origin, destination) {
    configFile.transitions.forEach(e => {
      if (
        e.source === origin.stage &&
        e.destination === destination &&
        e.actions !== undefined &&
        e.actions.length > 0 &&
        e.actions[0].assetType === origin.asset.assetType
      ) {
        // guardo en schema los actions y el asset que se esta haciendo la transicion
        const props = {
          actions: e.actions,
          origin,
          destination,
          transitionName: e.nombre,
          stages: configFile.stages.map(stage => stage.stages).flat(),
          configId: configFile.configId
        };

        setFormProps(props);
      }
    });
  }

  // Funcion para cuando un asset cambia de estado o hace una transicion
  async function transtion (asset, stages) {
    setFormTranstion(asset, stages.id);
    return 0;
  }

  // Funcion para ver en tiempo real si se puede hacer una trasicion cuando se arrastra un asset
  function canTransitionDrop (drop, stages) {
    const trasition = configFile.transitions.map(transtion => {
      if (
        transtion.source === drop.stage &&
        transtion.destination === stages.id && transtion.actions.filter(transition => transition.assetType === drop.asset.assetType).length > 0
      ) {
        return true;
      } else {
        return false;
      }
    });
    // como map devuelve un array verifico que contenga algun valor true
    return !!trasition.includes(true);
  }

  const [, drop] = useDrop({
    accept: 'box',
    drop: async asset => await transtion(asset, stages),
    /* canDrop evita que el asset card se transicione asi mismo y solamente podra hacerlo en la que se declare en el archivo de configuracion */
    canDrop: (drop, monitor) => canTransitionDrop(drop, stages),
    collect: monitor => ({
      isOver: monitor.isOver(),
      anDrop: monitor.canDrop()
    })
  });

  return (
    <div id={stages.id} ref={drop}>
      {form && <TransitionForm {...formProps} setForm={setForm} />}
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <Typography
            className={classes.title}
            color='textSecondary'
            gutterBottom
          >
            {funcTranslateHelper(stages.name)}
            <button
              className='bx--accordion__arrow-custom'
              onClick={() => setOpen(!open)}
              aria-controls='example-collapse-text'
              aria-expanded={open}
            >
              <ChevronDown16 />
            </button>
          </Typography>
          <Typography
            className={classes.items}
            color='textSecondary'
            gutterBottom
          >
            {filteredAssets === undefined
              ? funcTranslateHelper('0 Items')
              : filteredAssets.filter(
                assets => assets.currentStage === stages.id
              ).length + funcTranslateHelper(' Items')}
          </Typography>
          <div className={classes.bottom} style={{ background: '#78A9FF' }} />
        </CardContent>
      </Card>
      <Collapse in={open}>
        {!stages.stages && (
          <Grid item>
            <div className={classes.scroll} id='scroll'>
              <Assets
                origin={stages.id}
                assets={assets}
                stages={stages}
                filteredAssets={filteredAssets}
                configFile={configFile}
              />
            </div>
          </Grid>
        )}
      </Collapse>
    </div>
  );
}

export default SubStages;
